var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _path5, _circle, _g, _linearGradient4, _path6, _linearGradient5, _path7, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidStudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJma",
    x1: 5,
    x2: 18.125,
    y1: 11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#073042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073042"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJma)",
    d: "M18.125,7L18,15H5c0,0,0-2.567,0-4.5S6.567,7,8.5,7S18.125,7,18.125,7z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJmb",
    x1: 21.417,
    x2: 24.385,
    y1: 0.205,
    y2: 17.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ddc84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#37c777"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJmb)",
    d: "M30.009,5.627l1.85-3.117 c0.282-0.475,0.125-1.089-0.349-1.371c-0.475-0.283-1.088-0.125-1.371,0.349l-1.945,3.276C26.889,4.276,25.478,4,24,4 s-2.889,0.276-4.195,0.765L17.86,1.489c-0.282-0.474-0.895-0.632-1.371-0.349c-0.475,0.282-0.631,0.896-0.349,1.371l1.85,3.117 c-3.301,1.92-5.608,5.362-5.94,9.373H35.95C35.618,10.989,33.311,7.547,30.009,5.627z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJmc",
    x1: 24,
    x2: 24,
    y1: 1,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopOpacity: 0.15
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJmc)",
    d: "M30.009,5.627l1.85-3.117 c0.282-0.475,0.125-1.089-0.349-1.371c-0.475-0.283-1.088-0.125-1.371,0.349l-1.945,3.276C26.889,4.276,25.478,4,24,4 s-2.889,0.276-4.195,0.765L17.86,1.489c-0.282-0.474-0.895-0.632-1.371-0.349c-0.475,0.282-0.631,0.896-0.349,1.371l1.85,3.117 c-3.301,1.92-5.608,5.362-5.94,9.373H35.95C35.618,10.989,33.311,7.547,30.009,5.627z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,12c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S20.103,12,19,12z M19,9.999V10V9.999z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19,11.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S19.827,11.5,19,11.5z",
    opacity: 0.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 10,
    r: 1,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,12c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S30.103,12,29,12z M29,9.999V10V9.999z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,11.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S29.827,11.5,29,11.5z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 10,
    r: 1,
    fill: "#fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJmd",
    x1: 20.52,
    x2: 26.881,
    y1: 7.763,
    y2: 43.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#4f8fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#3f73cc"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJmd)",
    d: "M39.5,14c-0.494,0-30.14,0-31,0 C6.567,14,5,12.433,5,10.5c0,0.001,0,25.067,0,27S6.567,41,8.5,41C9.36,41,43,41,43,41s0-21.567,0-23.5S41.433,14,39.5,14z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJme",
    x1: 38.092,
    x2: 43.041,
    y1: 18.365,
    y2: 46.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#073042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073042"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJme)",
    d: "M39.5,21h-1c-0.276,0-0.5,0.224-0.5,0.5 v25c0,0.276,0.224,0.5,0.5,0.5h1c1.933,0,3.5-1.567,3.5-3.5v-26C43,19.433,41.433,21,39.5,21z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.119,41h5.526l2.26-4.802c0.205-0.435,0.614-0.695,1.095-0.695s0.89,0.26,1.095,0.695L27.354,41 h5.527l-5.936-12.612C27.926,27.535,28.5,26.297,28.5,25c0-1.909-1.215-3.596-3-4.227V19c0-0.827-0.673-1.5-1.5-1.5 s-1.5,0.673-1.5,1.5v1.773c-1.785,0.631-3,2.318-3,4.227c0,1.297,0.574,2.535,1.555,3.388L15.119,41z M24,23.5 c0.827,0,1.5,0.673,1.5,1.5s-0.673,1.5-1.5,1.5s-1.5-0.673-1.5-1.5S23.173,23.5,24,23.5z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.567,41h6.631l2.16-4.589c0.173-0.368,0.507-0.408,0.643-0.408s0.469,0.04,0.643,0.408 L26.802,41h6.631l-5.881-12.497C28.47,27.573,29,26.314,29,25c0-2.001-1.201-3.782-3-4.567V19c0-1.103-0.897-2-2-2s-2,0.897-2,2 v1.433c-1.799,0.785-3,2.565-3,4.567c0,1.314,0.53,2.573,1.448,3.503L14.567,41z M24,24c0.551,0,1,0.449,1,1s-0.449,1-1,1 s-1-0.449-1-1S23.449,24,24,24z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2BO4kwcwzS8K~3Z74MpJmf",
    x1: 19.382,
    x2: 24.591,
    y1: 18.799,
    y2: 48.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#073042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#073042"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2BO4kwcwzS8K~3Z74MpJmf)",
    d: "M33.768,44.061l-7.444-15.819 C27.335,27.515,28,26.337,28,25c0-1.858-1.28-3.411-3-3.858V19c0-0.552-0.448-1-1-1s-1,0.448-1,1v2.142c-1.72,0.447-3,2-3,3.858 c0,1.337,0.665,2.515,1.676,3.242l-7.44,15.811c-0.424,0.901-0.201,2.025,0.62,2.588c1.047,0.718,2.437,0.309,2.954-0.79 l4.643-9.866c0.616-1.309,2.479-1.309,3.095,0l4.643,9.866C30.531,46.576,31.25,47,32.001,47c0.411,0,0.832-0.128,1.203-0.402 C33.982,46.024,34.18,44.936,33.768,44.061z M24,23c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S22.897,23,24,23z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidStudio);
export default __webpack_public_path__ + "static/media/android-studio.3c247d6ac7bf6c406982cb08148f83d4.svg";
export { ForwardRef as ReactComponent };